import { pipe } from 'fp-ts/function';
import { Fragment } from 'react';
import { Stack, StackItem } from '@optimus-web/core';
import { TabsConfig } from '../../modules/modalManager';
import createSidebar, { SidebarContent, SidebarContentProps, SidebarContentWrapper } from './createSidebar';
import SidebarTitle from './SidebarTitle';

const SidebarComponentWrapper = ({
    children,
    withContentSpacing,
}: React.PropsWithChildren<{ withContentSpacing: boolean }>) =>
    withContentSpacing ? (
        <Stack spacing="200">
            <StackItem grow padding="200">
                {children}
            </StackItem>
        </Stack>
    ) : (
        <Fragment>{children}</Fragment>
    );

export interface SidebarComponentProps {
    tabsConfig?: TabsConfig;
}

const commanderSidebarFactory =
    <P extends {}>(SidebarComponent: React.ComponentType<SidebarComponentProps & P>) =>
    (props: SidebarContentProps & P) => {
        const { showTitle, actions, onClose, title, tabsConfig, withContentSpacing = true, ...other } = props;
        const sidebarTitleProps = { showTitle, onClose, actions, title, tabsConfig };
        const sidebarComponentProps = { ...(other as P), tabsConfig };

        return (
            <SidebarContentWrapper>
                <SidebarTitle {...sidebarTitleProps} data-test-sidebar-title />
                <SidebarContent data-test-sidebar-content>
                    <SidebarComponentWrapper withContentSpacing={withContentSpacing}>
                        <SidebarComponent {...sidebarComponentProps} />
                    </SidebarComponentWrapper>
                </SidebarContent>
            </SidebarContentWrapper>
        );
    };

/** @deprecated Use new Sidebar from DS vision */
export const CommanderSidebar = <P extends {}>(SidebarComponent: React.ComponentType<SidebarComponentProps & P>) =>
    pipe(SidebarComponent, commanderSidebarFactory, createSidebar);
